class MFRFloatingCTA {
  constructor( i, e ) {
      this.$index = i;
      this.$element = $( e );

      this.selectors = {
          button: "button",
          productTopAddToCart: ".mfr-product__top .add-to-cart"
      }

      this.init();
  }

  init() {
      this.$addToCart = $( this.selectors.productTopAddToCart );
      this.$button = this.$element.find( this.selectors.button );

      this.updateButton();
      this.initGSAP();
      this.initEvent();
  }

  updateButton() {
      this.$button.html(
          this.$addToCart.html()
      )
  }

  initGSAP() {
      if( $( window ).width() <= 1023 )
          $("footer.footer").css(
              "padding-bottom",
              parseInt($("footer.footer").css("padding-bottom").replace( "px", "" )) + 86
          );

      ScrollTrigger.create({
        trigger: this.$addToCart,
        start: `top 100%-=86px`,
        end: "bottom top",
        onEnter: () => {this.$element.addClass("hide-button")},
        onEnterBack: () => {this.$element.addClass("hide-button")},
        onLeave: () => {this.$element.removeClass("hide-button")},
        //onLeaveBack: () => {console.log('onLeaveBack');this.$element.removeClass("hide-button")}
      });
  }

  initEvent() {
      this.$button.on( "click", () => this.$addToCart.click() );
  }
}